const state = {
  roles: [
    {
      role: 'admin',
      allowedRoutes: [
        'dashboard',
        'platform',
        'leads',
        'my-account',
        'user',
        'product',
        'lead-tabulation',
        'repurchase',
        'squad',
        'attribute',
        'commission',
        'management-commission',
        'management-hero',
        'insight',
        'coupon',
        'send-report',
        'ranking',
        'conquest',
        'app-chat',
        'cost-report',
        'app-message',
        'follow-up',
        'leads-upload',
        'lead',
      ]
    },
    {
      role: 'management',
      allowedRoutes: [
        'dashboard',
        'platform',
        'leads',
        'my-account',
        'user',
        'product',
        'lead-tabulation',
        'repurchase',
        'squad',
        'attribute',
        'coupon',
        'app-message',
        'commission',
        'management-commission',
        'management-hero',
        'app-chat',
        'cost-report',
        'follow-up',
        'lead',
      ]
    },
    {
    //   role: 'operation-tq',
      role: 'trainee', //estagiario
      allowedRoutes: [
        'dashboard',
        'platform',
        'leads',
        'my-account',
        'user',
        'app-chat',
        'app-message',
        'coupon',
        'product',
        'commission',
        'lead-tabulation',
        'attribute',
        'squad',
        'follow-up',
        'lead'
      ]
    },
    {
      // B2B admin
      role: 'squad-leader', // LS
      allowedRoutes: [
        'dashboard',
        'platform',
        'leads',
        'my-account',
        'app-chat',
        'app-message',
        'follow-up',
        'lead'
      ]
    },
    {
        role: 'operator',
        allowedRoutes: [
            'dashboard',
            'platform',
            'leads',
            'my-account',
            'repurchase',
            'commission',
            'lead'
        ]
    },
    {
        role: 'platform',
        allowedRoutes: [
            'dashboard',
            'platform',
            'leads',
            'my-account',
            'app-chat',
            'cost-report',
            'leads-upload',
            'custom-indicators',
            'leads-journey',
            'operational-performance',
            'insight-conversations',
            'insight-business',
            'leads-insight'
        ]
    },
  ],
 
  features: [
    // commission
    {
        feature: 'create-commission',
        allowedRoles: [
            'admin',
            'management',
        ]
    },
    {
        feature: 'filter-user-commission',
        allowedRoles: [
            'admin',
            'management',
            'trainee'
        ]
    },
    {
        feature: 'commission',
        allowedRoles: [
            'admin',
            'management',
            'trainee',
            'operator'
        ]
    },

    // lead
    {
        feature: 'button-channel',
        allowedRoles: [
            'admin',
            'operator',
        ]
    },
    {
        feature: 'export',
        allowedRoles: [
            'admin',
            'management',
            'trainee',
        ]
    },
    {
        feature: 'visible-columns',
        allowedRoles: [
            'admin',
            'management',
            'operator',
            'trainee',
            'squad-leader',
        ]
    },
    {
        feature: 'create-lead',
        allowedRoles: [
            'admin',
            'management',
            'operator',
        ]
    },
    {
        feature: 'delete-lead',
        allowedRoles: [
            'admin',
            'management',
        ]
    },
    {
        feature: 'visible-info-full',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
        ]
    },
    {
        feature: 'upload-leads',
        allowedRoles: [
            'admin',
            'platform'
        ]
    },
    {
        feature: 'lead-tabulation',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
            'operator'
        ]
    },
    {
        feature: 'dispatcher-transshipment',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
        ]
    },
    {
        feature: 'reset-lead',
        allowedRoles: [
            'admin',
            'management',
        ]
    },

    // product
    {
        feature: 'product',
        allowedRoles: [
            'admin',
            'management',
            'trainee'
        ]
    },
    {
        feature: 'create-product',
        allowedRoles: [
            'admin',
            'management',
        ]
    },

    // tabulation
    {
        feature: 'list-tabulation',
        allowedRoles: [
            'admin',
            'management',
            'trainee',
        ]
    },
    {
        feature: 'create-tabulation',
        allowedRoles: [
            'admin',
            'management',
        ]
    },
    {
        feature: 'edit-tabulation',
        allowedRoles: [
            'admin',
            'management',
        ]
    },

    // squad
    {
        feature: 'list-squad',
        allowedRoles: [
            'admin',
            'trainee',
            'management',
        ]
    },
    {
        feature: 'create-squad',
        allowedRoles: [
            'admin',
            'management',
            'management'
        ]
    },
    {
        feature: 'edit-squad',
        allowedRoles: [
            'admin',
            'management',
        ]
    },

    // attribute
    {
        feature: 'list-attribute',
        allowedRoles: [
            'admin',
            'management',
        ]
    },
    {
        feature: 'create-attribute',
        allowedRoles: [
            'admin',
            'management',
        ]
    },

    // user
    {
        feature: 'user',
        allowedRoles: [
            'admin',
            'management',
            'trainee',
        ]
    },
    {
        feature: 'create-user',
        allowedRoles: [
            'admin',
            'management',
        ]
      },
    {
        feature: 'edit-user',
        allowedRoles: [
            'admin',
            'management',
        ]
    },
    {
          feature: 'create-user-admin',
          allowedRoles: [
              'admin',
          ]
    },
    {
        feature: 'online-user',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
            'operator',
            'trainee',

        ]
    },

    // coupon
    {
        feature: 'list-coupon',
        allowedRoles: [
            'admin',
            'management',
            'trainee'
        ]
      },
      {
          feature: 'create-coupon',
          allowedRoles: [
              'admin',
              'management',
          ]
      },
      {
          feature: 'edit-coupon',
          allowedRoles: [
              'admin',
              'management',
          ]
      },


    // saas feature
    {
        feature: 'cost-report',
        allowedRoles: [
            'admin',
            'management',
            'platform'
        ]
    },

    // message
    {
        feature: 'messages',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
            'trainee',
        ]
    },
    {
      feature: 'follow-up',
      allowedRoles: [
          'admin',
          'management',
          'trainee',
          'squad-leader'
      ]
    },
    {
        feature: 'app-chat',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
            'trainee',
            'platform'
        ]
    },
    {
        feature: 'list-app-chat',
        allowedRoles: [
            'admin',
            'platform'
        ]
    },
    {
        feature: 'delete-message',
          allowedRoles: [
              'admin',
              'management',
          ]
    },
    {
        feature: 'active-message',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
        ]
    },
    {
        feature: 'hsm-message',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
        ]
    },
    {
        feature: 'create-message',
        allowedRoles: [
            'admin',
            'management',
            'squad-leader',
        ]
    },

    // metrics
    {
        feature: 'management-commission',
        allowedRoles: [
            'admin',
            'management',
        ]
    },
    {
        feature: 'management-hero',
        allowedRoles: [
            'admin',
            'management',
        ]
    },

    // others
    {
        feature: 'repurchase',
        allowedRoles: [
            'admin',
            'platform',
            'operator',
        ]
    },
    {
        feature: 'insight',
        allowedRoles: [
            'admin'
        ]
    },
    {
        feature: 'ranking',
        allowedRoles: [
            'admin'
        ]
    },
    {
        feature: 'conquest',
        allowedRoles: [
            'admin'
        ]
    },
    {
        feature: 'lean-paging',
        allowedRoles: [
            'operator'
        ]
    },
    {
        feature: 'widget-csat-commissions',
        allowedRoles: [
            'operator'
        ]
    },
    {
        feature: 'widget-csat-performance',
        allowedRoles: [
            'admin',
            'platform',
            'management',
            'trainee',
        ]
    },
    {
        feature: 'filter-plugin',
        allowedRoles: [
            'admin',
            'platform',
            'management',
        ]
    },
    {
        feature: 'created-notification-message',
        allowedRoles: [
            'admin',
        ]
    },
    {
        feature: 'filter-lead-amount',
        allowedRoles: [
            'admin',
            'squad-leader',
            'management',
            'trainee'
        ]
    },
    {
        feature: 'operational-performance',
        allowedRoles: [
            'admin',
            'platform',
        ]
    },
  ]
}

export default state
